import eventService from './eventService';
import businessRules from '../constants/businessRules/businessRules';
import { updateVersionHistoryItemSavingStatus } from '../actions/versionHistory';
import { ERR_SAVE_TIMEOUT } from '../constants/Errors';

export default {
    timer: null,
    set(dispatch) {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = setTimeout(() => {
            eventService.notify(ERR_SAVE_TIMEOUT, true);
            dispatch(updateVersionHistoryItemSavingStatus({ isSaving: false }));
            eventService.triggerSave();
        }, businessRules.SAVE_TIMEOUT);
    },
    clear() {
        clearInterval(this.timer);
    },
};
